import * as React from "react";
import { cn } from "@/lib/utils";

interface TableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
    /** When false, disables the default pl-8/pr-8 on the first/last cell. Defaults to true. */
    applyEdgePadding?: boolean;
}

const TableRow = React.forwardRef<HTMLTableRowElement, TableRowProps>(
    ({ applyEdgePadding = true, className, ...props }, ref) => (
        <tr
            ref={ref}
            className={cn(
                "border-b border-table-border bg-table-row transition-colors hover:bg-table-row-hover data-[state=selected]:bg-table-row-selected",
                applyEdgePadding &&
                    "[&>td:first-child]:pl-8 [&>td:last-child]:pr-8",
                className,
            )}
            {...props}
        />
    ),
);
TableRow.displayName = "TableRow";

export { TableRow };
export type { TableRowProps };
